/* ---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *-------------------------------------------------------------------------------------------- */
import { registerLanguage } from 'monaco-editor/esm/vs/basic-languages/_.contribution.js'
registerLanguage({
  id: 'freemarker',
  extensions: [
    '.ftl'
  ],
  firstLine: '',
  aliases: ['FREEMARKER', 'freemarker'],
  // mimetypes: ['text/freemarker'],
  loader: function () { return import('./freemarker.js') }
})
